import React, { useState } from 'react';
import './OpeningSequence.css';

export default function OpeningSequence({ onOpenGift }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);

  const handleOpen = () => {
    if (isOpen) return; // Prevent double clicks
    setIsOpen(true);
    
    // After envelope opens, wait a bit, then fade out and unmount
    setTimeout(() => {
      setIsFadingOut(true);
      setTimeout(() => {
        onOpenGift(); // Tells App.js to show the Gallery
      }, 1200); // Wait for fade out animation
    }, 2500); // 2.5s for envelope to stay open before fading
  };

  return (
    <div className={`os-container ${isFadingOut ? 'os-fade-out' : ''}`}>
      <div className="os-stars"></div>
      
      <div className="os-content">
        <h1 className={`os-title ${isOpen ? 'os-title-hide' : ''}`}>
          You have a special delivery...
        </h1>

        <div className={`envelope-wrapper ${isOpen ? 'is-open' : ''}`} onClick={handleOpen}>
          <div className="envelope">
            {/* Front flap (top) */}
            <div className="envelope-flap"></div>
            {/* The letter inside */}
            <div className="envelope-letter">
              <p>Happy,<br/>Happy<br/>Birthday.</p>
            </div>
            {/* Envelope body */}
            <div className="envelope-body">
              <div className="envelope-front"></div>
            </div>
            {/* Wax Seal */}
            <div className={`wax-seal ${isOpen ? 'seal-break' : ''}`}>
              <span>&#x2764;</span>
            </div>
          </div>
        </div>

        <p className={`os-hint ${isOpen ? 'os-title-hide' : ''}`}>
          Click the envelope to open
        </p>
      </div>
    </div>
  );
}
